// extracted by mini-css-extract-plugin
export default {"products":"Yu-z","card":"Zu-z","oosMessaging":"_u-z"};